import '../../styles/layouts/theme.scss';
import 'swiper/css';

import View from '../app/View';
import Inview from '../../components/global/inview';

// Globals
import Promobar from '../../components/global/promobar';
import CountdownTimer from '../../components/global/countdown-timer';
import PromobarCarousel from '../../components/global/promobar-carousel';
import Video from '../../components/global/video';
import '../../components/global/four04';

// Footer
import Footer from '../../components/footer-components/footer';
import FooterLinks from '../../components/footer-components/footer-links';
import FooterLegal from '../../components/footer-components/footer-legal';
import FooterForms from '../../components/footer-components/footer-forms';

// Homepage
import HeroCarousel from '../../components/homepage/hero-carousel';
import TwoColumn from '../../components/homepage/two-column';
import ThreeColumn from '../../components/homepage/three-column';
import EditorialCarousel from '../../components/homepage/editorial-carousel';
import '../../components/homepage/editorial-carousel-slide';
import ProductCarousel from '../../components/homepage/product-carousel';

// Header
import Header from '../../components/header-components/header';
import Navigation from '../../components/header-components/navigation';
import NavigationDesktop from '../../components/header-components/navigation-desktop';
import NavigationMobile from '../../components/header-components/navigation-mobile';
import NavigationMenu from '../../components/header-components/navigation-menu';
import NavigationSubmenu from '../../components/header-components/navigation-submenu';
import NavigationFooter from '../../components/header-components/navigation-footer';
import NavigationMenuLink from '../../components/header-components/navigation-menu-link';
import NavigationMenuButton from '../../components/header-components/navigation-menu-button';
import NavigationSearchMobile from '../../components/header-components/navigation-search-mobile';
import SubmenuImageLinks from '../../components/header-components/submenu-image-links';
import SubmenuLinks from '../../components/header-components/submenu-links';
import SubmenuLinksAndImageBlock from '../../components/header-components/submenu-links-and-image-block';
import SubmenuImageBlocks from '../../components/header-components/submenu-image-blocks';
import SearchDrawer from '../../components/header-components/search-drawer';
import '../../components/header-components/search-drawer-top-searches';

// Product Card
import ProductCard from '../../components/product-card/product-card';
import ProductQuickAddCard from '../../components/product-card/product-quick-add-card';
import '../../components/product-card/product-card-badge';
import '../../components/product-card/product-card-images';
import '../../components/product-card/product-card-price';
import '../../components/product-card/product-card-swatches';
import '../../components/product-card/product-card-swatch';
import '../../components/product-card/product-card-rating';
import '../../components/product-card/product-card-quick-shop-button';
import '../../components/product-card/product-card-video';

// Swatches
import '../../components/global/swatch';

// Account
import AccountDrawer from '../../components/account/account-drawer';
import AccountLoginRegister from '../../components/account/account-login-register';
import AccountLoginForm from '../../components/account/account-login-form';
import AccountRegisterForm from '../../components/account/account-register-form';

// Mini Cart
import MiniCart from '../../components/cart/mini-cart';
import MiniCartHeader from '../../components/cart/mini-cart-header';
import '../../components/cart/mini-cart-promo';
import MiniCartProgress from '../../components/cart/mini-cart-progress';
import MiniCartGwp from '../../components/cart/mini-cart-gwp';
import MiniCartRecommendations from '../../components/cart/mini-cart-recommendations';
import EmptyCartRecommendations from '../../components/cart/empty-cart-recommendations';
import '../../components/cart/empty-cart';
import '../../components/cart/empty-cart-collection-cards';

// Cart Item
import CartItem from '../../components/cart/cart-item';

// Upsells
import CartUpsell from '../../components/cart/cart-upsell';
import CartUpsells from '../../components/cart/cart-upsells';
import CartFooterProduct from '../../components/cart/cart-footer-product';

// Swym
import '../../components/swym-wishlist/swym-button';
import '../../components/swym-wishlist/swym-modal';
import '../../components/swym-wishlist/swym-notification/_swym-notification.scss';

// Quick Shop
import QuickShop from '../../components/quick-shop/quick-shop';
import QuickShopProductImages from '../../components/quick-shop/quick-shop-product-images';
import QuickShopProductOptions from '../../components/quick-shop/quick-shop-product-options';
import QuickShopProductForm from '../../components/quick-shop/quick-shop-product-form';
import QuickShopProductCard from '../../components/quick-shop/quick-shop-product-card';
import '../../components/quick-shop/quick-shop-product-info';
import '../../components/quick-shop/quick-shop-product-option';

// Autocomplete Search
import GlobalAutocompleteSearchInstance from '../../components/autocomplete-search/autocomplete-search';
import AutocompleteSearchInput from '../../components/autocomplete-search/autocomplete-search-input';
import AutocompleteSearchProductHits from '../../components/autocomplete-search/autocomplete-search-product-hits';
import AutocompleteSearchCollectionHits from '../../components/autocomplete-search/autocomplete-search-collection-hits';
import AutocompleteSearchBlogPageHits from '../../components/autocomplete-search/autocomplete-search-blog-page-hits';
import AutocompleteSearchEmptyState from '../../components/autocomplete-search/autocomplete-search-empty-state';

// Autocomplete Search Init
GlobalAutocompleteSearchInstance.init();

const layoutView = new View();
layoutView.init({
  Inview,
  Header,
  Navigation,
  NavigationDesktop,
  NavigationMobile,
  NavigationMenu,
  NavigationSubmenu,
  NavigationFooter,
  NavigationMenuLink,
  NavigationMenuButton,
  NavigationSearchMobile,
  SubmenuImageLinks,
  SubmenuLinks,
  SubmenuLinksAndImageBlock,
  SubmenuImageBlocks,
  SearchDrawer,
  HeroCarousel,
  TwoColumn,
  EditorialCarousel,
  ProductCarousel,
  ThreeColumn,
  Footer,
  FooterForms,
  FooterLinks,
  FooterLegal,
  Promobar,
  CountdownTimer,
  PromobarCarousel,
  Video,
  AccountDrawer,
  AccountLoginRegister,
  AccountLoginForm,
  AccountRegisterForm,
  MiniCart,
  MiniCartHeader,
  MiniCartProgress,
  MiniCartGwp,
  MiniCartRecommendations,
  EmptyCartRecommendations,
  QuickShop,
  AutocompleteSearchInput,
  AutocompleteSearchProductHits,
  AutocompleteSearchCollectionHits,
  AutocompleteSearchBlogPageHits,
  AutocompleteSearchEmptyState,
});

const productCardView = new View();
productCardView.init({
  ProductCard,
  ProductQuickAddCard,
});

const cartItemView = new View();
cartItemView.init({
  CartItem,
  CartUpsell,
  CartUpsells,
  CartFooterProduct,
});

const quickShopView = new View();
quickShopView.init({
  QuickShopProductImages,
  QuickShopProductOptions,
  QuickShopProductForm,
  QuickShopProductCard,
});

const remountQuickShopView = new View();
remountQuickShopView.init({
  QuickShopProductImages,
});

// Start must be called after the view inits so autocomplete search
// components can first mount and add required instantsearch widgets
// to the global autocomplete search instance.
GlobalAutocompleteSearchInstance.start();

document.addEventListener('mountproductcards', () => {
  productCardView.mountComponents();
});

document.addEventListener('mountcartitems', () => {
  cartItemView.mountComponents();
});

document.addEventListener('mountquickshop', () => {
  quickShopView.mountComponents();
});

document.addEventListener('remountquickshop', () => {
  remountQuickShopView.mountComponents();
});
